export default "__VITE_ASSET__51b1ec0c__"